import { PopupTheme, SternumTheme } from '@sternum/ui';

import { Colors, Shadows } from '../constants';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function SBOMLightPopupTheme(_theme: SternumTheme): Partial<PopupTheme> {
  return {
    backgroundColor: Colors.White,
    boxShadow: Shadows.DialogLightMode,
    borderRadius: '6px',
  };
}
